import { render, staticRenderFns } from "./CertificateTemplatePreview.vue?vue&type=template&id=940c5302&scoped=true"
import script from "./CertificateTemplatePreview.vue?vue&type=script&lang=js"
export * from "./CertificateTemplatePreview.vue?vue&type=script&lang=js"
import style0 from "./CertificateTemplatePreview.vue?vue&type=style&index=0&id=940c5302&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940c5302",
  null
  
)

export default component.exports